<script setup lang="ts">
import {
	RadioGroupRoot,
	type RadioGroupRootEmits,
	type RadioGroupRootProps,
	useForwardPropsEmits,
} from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps<RadioGroupRootProps & { class?: string }>()
const emits = defineEmits<RadioGroupRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
	<RadioGroupRoot :class="cn('gap-2 grid', props.class)" v-bind="forwarded">
		<slot />
	</RadioGroupRoot>
</template>
